export const isSwipeIntentionTowardsRight = (degrees, dy) =>
  (degrees < 0 && degrees > -45 && dy > 0) || (degrees > 0 && degrees < 45 && dy < 0);

export const isSwipeIntentionTowardsLeft = (degrees, dy) =>
  (degrees < 0 && degrees > -45 && dy < 0) || (degrees > 0 && degrees < 45 && dy > 0);
